import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { initUniversalLinkRouting } from '@/platform'

/**
 * Route native Universal/App Link deep links (`https://app.maxflow.io/...`,
 * from push or email) into the SPA. Must be mounted inside the Router — same
 * shape as useOAuthReturn, its custom-scheme sibling.
 *
 * No-op on web.
 */
export function useUniversalLinkRouting(): void {
  const navigate = useNavigate()

  useEffect(() => {
    let dispose: (() => void) | undefined
    let cancelled = false

    void initUniversalLinkRouting((route) => navigate(route)).then((remove) => {
      if (cancelled) remove()
      else dispose = remove
    })

    return () => {
      cancelled = true
      dispose?.()
    }
  }, [navigate])
}
